<div class="munily-date-picker-modal__wrapper">
  <div class="munily-date-picker-modal__header">
    <h2 class="h6_500 munily-date-picker-modal__title" mat-dialog-title>
      {{ titleKey | translate }}
    </h2>
    <common-icon-button
      class="munily-date-picker-modal__close"
      variant="plain"
      icon="close"
      iconSet="material-icons-outlined"
      [ariaLabel]="closeAriaKey | translate"
      color="weak"
      type="filled"
      size="small"
      [stopClickPropagation]="true"
      (output)="onClose()"
    ></common-icon-button>
  </div>

  <mat-dialog-content class="munily-date-picker-modal__content">
    <div class="munily-date-picker-modal__calendar-wrap">
      <mat-calendar
        [selected]="selectedDate"
        [minDate]="minDate ?? undefined"
        [maxDate]="maxDate ?? undefined"
        [dateFilter]="dateFilter"
        (selectedChange)="onCalendarSelected($event)"
      ></mat-calendar>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="munily-date-picker-modal__actions">
    <common-buttons-outlined
      [label]="cancelKey | translate"
      [iconPosition]="false"
      (output)="onClose()"
    ></common-buttons-outlined>
    <common-buttons-filled
      [label]="confirmKey | translate"
      [iconPosition]="false"
      [disabled]="!selectedDate"
      (output)="onConfirm()"
    ></common-buttons-filled>
  </mat-dialog-actions>
</div>
